<div>
  <mat-card appearance="outlined" class="showCard">
    @for (transaction of transactions; track transaction; let first = $first) {
      <div>
        @if (!first) {
          <hr>
          }
          @for (field of transaction.original_data; track field?.fieldName) {
            <div>
              @if (field && field.value) {
                <div>
                  <div class="import-data-header">{{field.fieldName}}</div>
                  <span>{{field.value}}</span>
                </div>
              }
            </div>
          }
        </div>
      }
    </mat-card>
    <div class="table-details">
      <div class="search-row flex justify-flex-end align-items-start">
        <p-menu #menu appendTo="body" [popup]="true" [model]="bulkOptions"></p-menu>
        <button
          class="bulk-button search-row-space"
          [disabled]="!selectedRows.length"
          mat-raised-button
          label="Bulk Options"
          (click)="menu.toggle($event)"
          >
          Bulk Options
        </button>
        <ah-column-selector
          [options]="cols"
          [value]="fields"
          (onChange)="onSelectColumns($event)"
        ></ah-column-selector>

      </div>
      <p-table
        #tt
        dataKey="id"
        [columns]="fieldHeaderFields"
        [value]="rows"
        (onColReorder)="onColReorder($event)"
        [reorderableColumns]="true"
        [resizableColumns]="true"
        [(selection)]="selectedRows"
        styleClass="clickable shadow"
        >
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of columns; track col) {
              <th
                [pSortableColumn]="col.canonical_name"
                pReorderableColumn
                pResizableColumn
                >
                {{col.name}}
                <p-sortIcon [field]="col.canonical_name"></p-sortIcon>
              </th>
            }
            <th style="width: 5em;">
              <mat-checkbox
                class="row-checkbox"
                [ngModel]="selectedRows.length === rows.length"
                (change)="onSelectAll()"
                (click)="$event.stopPropagation()"
              ></mat-checkbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns">
          <tr>
            @for (col of columns; track col) {
              <td class="p-resizable-column">
                {{row[col.canonical_name]}}
              </td>
            }
            <td>
              <mat-checkbox
                class="row-checkbox"
                [checked]="isChecked(row)"
                (change)="onSelectRowCheckbox(row)"
                (click)="$event.stopPropagation()"
              ></mat-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
